/* eslint-disable react/jsx-no-useless-fragment */
import { Icon } from '@iconify/react';
import type { FC } from 'react';

import Text from '../Text';

type Props = {
  locations: string[];
  workType?: string | null;
};

const OfferLocation: FC<Props> = ({ locations, workType }) => {
  const location = locations.length ? locations[0] : null;
  return (
    <>
      {(location || workType) && (
        <div className="flex min-w-0 items-center gap-1">
          <Icon
            className="shrink-0 text-lg text-jb-neutral-800"
            icon="material-symbols-light:location-on"
          />
          <Text
            title={locations.join(', ')}
            variant="jb-body-medium"
            className="truncate text-jb-neutral-800"
          >
            {[location, workType].filter(Boolean).join(' · ')}
          </Text>
        </div>
      )}
    </>
  );
};

export default OfferLocation;
